import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DetailedCustomerProfile from './DetailedCustomerProfile';

class CustomerModalWithoutResetOption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  showDetails(customer, show) {
    const { sendNavigationRequest, } = this.props;
    if (!customer || !show) {
      return null;
    }
    return (
      <DetailedCustomerProfile customer={customer} sendNavigationRequest={sendNavigationRequest} />
    );
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  reset() {
    this.setState({
      status: null,
    });
  }

  updateUsernameNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Update Username',
      state: customerProfile,
    });
    this.handleClose();
  }

  removeUserNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Remove User',
      state: customerProfile,
    });
    this.handleClose();
  }

  transactionSearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Transaction Search',
      state: customerProfile,
    });
    this.handleClose();
  }

  scheduledTransactionSearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Scheduled Transaction Search',
      state: customerProfile.id,
    });
    this.handleClose();
  }

  conversationSearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Conversation Viewer',
      state: customerProfile,
    });
    this.handleClose();
  }

  managedPaySearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Managed Pay',
      state: customerProfile.id,
    });
    this.handleClose();
  }

  autoPaySearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Autopay',
      state: customerProfile,
    });
    this.handleClose();
  }

  render() {
    const {
      show, status,
    } = this.state;
    const { customer, } = this.props;

    if (!customer || !customer.customer) {
      return (
        <>
          <Button disabled variant="primary">
            Customer Details
          </Button>
        </>
      );
    }

    return (
      <>
        <div>
          <Button variant="primary" onClick={() => this.handleShow()}>
            Customer Details
          </Button>
          <Modal show={show} onHide={() => this.handleClose()} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>{customer.customer.id}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.updateUsernameNavigationRequest(customer.account)}
                >
                  Update Username
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.removeUserNavigationRequest(customer.account)}
                >
                  Remove User
                </button>

                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.transactionSearchNavigationRequest(customer.customer)}
                >
                  Transaction Search
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.scheduledTransactionSearchNavigationRequest(customer.customer)}
                >
                  Scheduled Transaction Search
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.conversationSearchNavigationRequest(customer.customer)}
                >
                  Conversation Viewer
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.managedPaySearchNavigationRequest(customer.customer)}
                >
                  Managed Pay Search
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.autoPaySearchNavigationRequest(customer.customer)}
                >
                  Autopay Search
                </button>
                <hr />
              </div>
              {this.showDetails(customer, show)}
            </Modal.Body>
          </Modal>
        </div>
        {status}
      </>
    );
  }
}

CustomerModalWithoutResetOption.propTypes = {
  customer: PropTypes.object.isRequired,
  sendNavigationRequest: PropTypes.func.isRequired,
};
export default CustomerModalWithoutResetOption;
